import { Component, OnInit } from '@angular/core';
import { Vozilo } from './vozilo';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-vozilo-modal-update',
  templateUrl: './vozilo-modal-update.component.html'
})
export class VoziloModalUpdateComponent extends BaseModalUpdateComponent<Vozilo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Vozilo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
